import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import css from './Toggle.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cln = classnames.bind(css);
export const Toggle = /*#__PURE__*/forwardRef(function Toggle({
  labels,
  onChange,
  checked,
  disabled = false,
  className,
  ...rest
}, ref) {
  return /*#__PURE__*/_jsxs("div", {
    className: css.container,
    children: [labels?.off ? /*#__PURE__*/_jsx("span", {
      className: css.offLabel,
      children: labels.off
    }) : null, /*#__PURE__*/_jsx("label", {
      className: css.label,
      children: /*#__PURE__*/_jsx("input", {
        type: "checkbox",
        onChange: onChange,
        checked: checked,
        disabled: disabled,
        className: cln(className, css.toggle),
        ref: ref,
        ...rest
      })
    }), labels?.on ? /*#__PURE__*/_jsx("span", {
      className: css.onLabel,
      children: labels.on
    }) : null]
  });
});
Toggle.propTypes = {
  /** Labels for ON and OFF state */
  labels: PropTypes.shape({
    on: PropTypes.string,
    off: PropTypes.string
  }),
  /** @ignore */
  onChange: PropTypes.func,
  /** Indicate if toggle is turned on */
  checked: PropTypes.bool,
  /** @ignore */
  disabled: PropTypes.bool,
  /** @ignore  */
  className: PropTypes.string
};